import React, {useState, useEffect} from 'react';
import {ThemeProvider, Confirm, ConfirmWrapper, ConfirmContent} from '@workboard/wobo-ui';
import './compliance.scss';
import UserServices from '../../../services/user.services';
import DOMPurify from 'dompurify';

import styled from "styled-components"

const StyledConfirm = styled(Confirm)`
  ${ConfirmWrapper} {
    max-height: 500px;
    width: 550px;
    header {
        display: none !important;
    }
  }
  ${ConfirmContent} { 
    padding-top: 24px !important;
    overflow-y: auto;
    max-height: 408px;
    ul {
        list-style-type: disc;
        padding-left: 1.5em;
    }
    b {
        > * {
            font-weight: bold;
        }
    }
  }
  ${ConfirmContent} + div {
      padding-top: 16px !important;
  }
`;

type MsTeamsPrivacyPolicyProps = {
    isOpen: boolean,
    content: string,
    url: string,
}

const MsTeamsPrivacyPolicy = (props: MsTeamsPrivacyPolicyProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);

    const ComplianceData = () => {
        return (
            <div className="compliance-data">
                <div className="compliance-data-content" id="complianceData"
                     dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.content)}}/>
            </div>
        );
    }

    const setOK = () => {
        setIsOpen(false);
        const userServices = new UserServices();
        userServices.pushEventForUser({type: 'msteamsprivacy'});
        window.location.replace(props.url);
    }

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isOpen])

    return (isOpen && (
        <ThemeProvider>
            <StyledConfirm
                aria-label="MS Teams Privacy Policy Notification"
                isOpen={isOpen}
                onSubmit={() => setOK()}
                submitOnly={true}
                className="complianceBgn"
            >
                <ComplianceData/>
            </StyledConfirm>
        </ThemeProvider>
    ));
}

export default MsTeamsPrivacyPolicy;